<template>
	<section
		class="overlay"
		:class="{ fullscreen: fullscreen, lightbox: lightbox }"
		v-if="isVisible"
		@click.self="close"
		:id="id"
	>
		<article class="modal" v-show="isVisible">
			<button class="button-close" @click="close"><i class="fa fa-times"></i></button>

			<slot :indexModal="indexModal" />
		</article>
	</section>
</template>

<script>
export default {
	data() {
		return {
			isVisible: this.visible,
			indexModal: 0,
		};
	},

	props: {
		visible: {
			type: Boolean,
			default: false,
			required: false,
		},

		id: {
			type: String,
			required: true,
		},

		fullscreen: {
			type: Boolean,
			default: false,
			required: false,
		},

		lightbox: {
			type: Boolean,
			default: false,
			required: false,
		},
	},

	methods: {
		close() {
			this.isVisible = false;
			this.enableScroll();
		},
		disableScroll() {
			const $html = document.documentElement;
			$html.classList.add('overlay-visible');
		},

		enableScroll() {
			const $html = document.documentElement;
			$html.classList.remove('overlay-visible');
		},
	},

	mounted() {
		this.$root.$on('showModal', paramId => {
			if (this.id === paramId) {
				this.isVisible = true;
				this.disableScroll();
			}
		});

		this.$root.$on('indexGalleryStart', index => {
			this.indexModal = index
			console.log(index);
		});

		this.$root.$on('hideModal', id => {
			if (this.id === id) {
				this.isVisible = false;
				this.enableScroll();
			}
		});
	},

	destroyed() {
		this.enableScroll();
	},

	watch: {
		$route(newVal) {
			this.isVisible = newVal.meta && newVal.meta.isVisible;
		},
	},
};
</script>

<style lang="stylus"></style>
